<template>
  <div>
    <app-read-options
      style="width: 100%;"
      :disabled="disabled"
      :clearable="false"
      size="mini"
      multiple
      v-model="valueSync"
      url="jushuitan_orders/read_options"
      label-field="display_text"
      :label-format="displayText"
      :params="params"
      :onInitOptions="onInitOptions"
      ref="readOptionsRef"
    />
    <div class="button-container">
      <el-button
        type="primary"
        @click="handleAutoFillSalesLineItems"
        :disabled="valueSync.length === 0"
      >自动填充销售订单商品</el-button>

      <bean-import-button
        :customUpload="upload"
        button-text="导入聚水潭内部单号填充销售订单商品"
        :afterSuccessHandler="handleAfterUploadSuccess"
      />
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop, PropSync, Emit } from 'vue-property-decorator';
import { displayText } from '@/custom_models_extend';
import _ from 'lodash';

@Component
export default class FormItemJushuitanOrderIds extends Vue {
  @PropSync('value', { type: Array, default: () => [] }) valueSync;
  @Prop(Boolean) disabled;
  @Prop({ type: Object, default: () => ({}) }) params;
  @Prop({ type: Function }) onInitOptions;

  displayText = displayText;

  @Emit('autoFill')
  handleAutoFillSalesLineItems() {
    return [];
  }

  async fetchJushuitanOrders(ids = []) {
    if (!ids.length) {
      return [];
    }
    const data = await this.$request.get('jushuitan_orders/read_options', { id_in: ids, page: 0 });
    return data;
  }

  async upload(file) {
    const formData = new FormData();
    formData.append('o_id_xlsx', file);
    const res = await this.$request.post('jushuitan_orders/sales_line_items', formData);

    const ids = res.ids;
    const jushuitanOrders = await this.fetchJushuitanOrders(ids);
    if (this.$refs.readOptionsRef) {
      this.$refs.readOptionsRef.options = jushuitanOrders;
    }
    this.valueSync = _.uniq(this.valueSync.concat(ids));
    const items = res.items;
    if (items && items.length) {
      this.$emit('autoFill', items);
    }
  }

  handleAfterUploadSuccess() {
    // 避免bean-import-button 默认提示导入成功
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
